import { render, staticRenderFns } from "./TemplateFullFrame.vue?vue&type=template&id=de5aa20a&scoped=true&"
import script from "./TemplateFullFrame.vue?vue&type=script&lang=js&"
export * from "./TemplateFullFrame.vue?vue&type=script&lang=js&"
import style0 from "./TemplateFullFrame.vue?vue&type=style&index=0&id=de5aa20a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5aa20a",
  null
  
)

export default component.exports